import PropTypes from 'prop-types';
import React, { Component } from 'react';
import MetaDataWrapper from 'modules/Common/containers/MetaDataWrapper';
import { canonicalLink, metaDescription } from 'utils/seoUtils';
import config from 'config';

import {localDateShort, localFullDateNoDay, isoDate, isToday, getRelativeDay, getRelativeDayURI, isTomorrow} from 'utils/LocalDateTimeHelper';

import Tabs from 'modules/Common/components/Tabs';
import RacecardsMeetingSummary from './HorseRacingRacecardsMeetingSummary';

import DatePicker from 'modules/Common/components/DatePicker';
import CaretLink from 'modules/Common/components/CaretLink';

require('./HorseRacingRacecardsForDate.scss');

export default class HorseRacingRacecardsForDate extends Component {
  static propTypes = {
    routes: PropTypes.array.isRequired,
    date: PropTypes.string,
    meetingsByDate: PropTypes.object.isRequired,
    raceType: PropTypes.string
  };

  render() {
    var title;
    const convertToday = true;
    const convertTomorrow = true;
    // build the date navigation array
    const dateNav = [], date = new Date();
    for (let i = 0; i < 7; i++) {
      const urlPart = getRelativeDayURI(date, 0, {convertToday, convertTomorrow});
      const rawURLPart = getRelativeDayURI(date, 0, {convertToday: false, convertTomorrow: false});
      let alternatives = [];
      if(urlPart != rawURLPart)
      {
        alternatives = [{href: `/racing/racecards${rawURLPart}`, isIndex: isToday(date)}];
      }
      dateNav.push({ href: `/racing/racecards${urlPart}`,
                    text: localDateShort(date, {convertToday, convertTomorrow}),
                    isIndex: isToday(date),
                    alternatives
                    });
      date.setDate(date.getDate() + 1);
    }

    // add option for early entries
    dateNav.push({ href: `/racing/early-entries`,
                  text: 'Early Entries',
                  isIndex: false});

    const latestSelectableDate = getRelativeDay(new Date(), 6);
    const earlyEntriesStartDate = getRelativeDay(new Date(), 7);

    const racecardsDate = this.props.date ? isoDate(this.props.date) : isoDate(new Date()),
          meetings = this.props.meetingsByDate[racecardsDate] == null ? null : this.props.meetingsByDate[racecardsDate].meetings;

    let showNonRunnersButton;

    if(isToday(racecardsDate)){
      title = 'Today\'s Racecards';
      showNonRunnersButton = true;
    }
    else if (isTomorrow(racecardsDate)){
      title = 'Tomorrow\'s Racecards';
      showNonRunnersButton = false;
    }
    else{
      title = `${localFullDateNoDay(racecardsDate)} Racecards`;
      showNonRunnersButton = false;
    }

    var {link = []} =  canonicalLink(this.props.routes, {date: getRelativeDay(racecardsDate, 0, {convertToday, convertTomorrow})});
    if(!isToday(racecardsDate)){
      link.push({
        rel: "prev",
        href: `${config.canonicalBase}/racing/racecards${getRelativeDayURI(racecardsDate, -1, {convertToday, convertTomorrow})}`
      });
    }

    link.push({
      rel: "next",
      href: `${config.canonicalBase}/racing/racecards${getRelativeDayURI(racecardsDate, 1, {convertToday, convertTomorrow})}`
    });

    if (meetings === undefined || meetings === null) {
      return (
        <div className="hr-racing-racecards">
          <p className="hr-racing-racecards-error-message">Failed to load results.</p>
        </div>
      )
    }

    const courseList = [];
    meetings.forEach(({ meeting_summary: { course: { name = ''} = {}}} = {}) => courseList.push(name));
    const courses = courseList.join(', ');
    const metaDesc = `Racecards, form and betting for meetings including ${courses}`

    return (
      <div className="hr-racing-racecards">
        <MetaDataWrapper title={title} helmetProps={{...{link}, ...metaDescription(metaDesc)}}/>
        <div>
          <div className="hr-racing-racecards-header-title">
            <div className="hr-racing-racecards-header-title-text">
              <h1 className="page-main-title">{title}</h1>
            </div>
            <div className="hr-racing-racecards-header-title-date-picker">
              <DatePicker urlBase="/racing/racecards" date={racecardsDate} latestDate={latestSelectableDate}>
                <CaretLink to="/racing/early-entries">Early Entries (from {localFullDateNoDay(earlyEntriesStartDate)})</CaretLink>
              </DatePicker>
            </div>
          </div>
          <Tabs tabs={dateNav}/>
          {showNonRunnersButton && <div className="hr-non-runner-link"><CaretLink to="/racing/non-runners">See today's non-runners</CaretLink></div>}
        </div>
        <section className="hr-racing-content">
          {
            meetings && meetings.length > 0 ?
            <ul className="meetings">
              {meetings.map(meeting => (
                <li key={meeting.meeting_summary.meeting_reference.id}>
                  <RacecardsMeetingSummary
                    meeting={meeting}
                    date={racecardsDate}
                    dateIncrement={1}
                  />
                </li>
              ))}
            </ul>
          :
            <div className="hr-racing-racecards-none">
              <p>No meetings found</p>
            </div>
          }
        </section>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/components/HorseRacingRacecardsForDate.js